<template>
  <BasePanelWithHeader collapsable headerText="Agencies">
    <template v-slot:content>
      <v-row>
        <v-col class="ml-auto" cols="12" sm="auto">
          <v-text-field
            v-model="searchText"
            prepend-inner-icon="mdi-magnify"
            label="Search"
            clearable
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="auto" class="mt-4 mr-4">
          <BaseTooltipButton
            small
            @click="$refs.trackedBillAgencyForm.addTrackedBillAgency()"
            icon="mdi-plus"
            iconColor="white"
            buttonClass="primary"
            >Add Agency Permission
          </BaseTooltipButton>
        </v-col>
      </v-row>
      <v-data-table
        :headers="filteredHeaders"
        :items="trackedBillAgencies"
        :search="searchText"
        class="pt-4"
        :loading="loading"
        dense
      >
        <template v-slot:item.edit="{ item }">
          <BaseTooltipButton
            v-if="
              currentUserPermissionID == 1 || item.TrackedBillPermissionID != 1
            "
            small
            @click="$refs.trackedBillAgencyForm.editTrackedBillAgency(item)"
            iconColor="primary"
            icon="mdi-pencil"
            >Edit Agency Permission
          </BaseTooltipButton>
        </template>
        <template v-slot:item.delete="{ item }">
          <BaseTooltipButton
            v-if="
              currentUserPermissionID == 1 || item.TrackedBillPermissionID != 1
            "
            small
            @click="$refs.trackedBillAgencyDelete.deleteConfirm(item)"
            iconColor="primary"
            icon="mdi-delete"
            >Delete Agency Permission
          </BaseTooltipButton>
        </template>
      </v-data-table>
      <BaseDeleteConfirm
        ref="trackedBillAgencyDelete"
        :delete="deleteTrackedBillAgency"
        @refresh="refresh"
      >
        Are you sure you want to delete this tracked bill agency?
      </BaseDeleteConfirm>
      <TrackedBillAgencyDialogForm
        ref="trackedBillAgencyForm"
        :currentUserPermissionID="currentUserPermissionID"
        @refresh="refresh"
        :trackedBillID="trackedBillID"
      >
      </TrackedBillAgencyDialogForm>
    </template>
  </BasePanelWithHeader>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import TrackedBillAgencyDialogForm from '@components/form/add-edit/TrackedBillAgencyDialog'
export default {
  components: {
    TrackedBillAgencyDialogForm,
  },
  data: () => ({
    searchText: '',
  }),
  props: {
    trackedBillAgencies: {
      type: Array,
      required: true,
    },
    trackedBillID: {
      type: Number,
      required: true,
    },
    currentUserPermissionID: {
      type: Number,
      required: true,
    },
  },
  created() {},
  computed: {
    ...get('trackedBillAgency', ['loading']),
    headers() {
      return [
        {
          text: '',
          align: 'center',
          value: 'edit',
          visible: true,
          sortable: false,
        },
        {
          text: 'ID',
          align: 'center',
          sortable: true,
          value: 'ID',
          visible: false,
        },
        {
          text: 'Tracked Bill ID',
          align: 'center',
          sortable: true,
          value: 'TrackedBillID',
          visible: false,
        },
        {
          text: 'Agency',
          align: 'center',
          sortable: true,
          value: 'Agency.Name',
          visible: true,
        },
        {
          text: 'Permission',
          align: 'center',
          sortable: true,
          value: 'TrackedBillPermission.Description',
          visible: true,
        },
        {
          text: '',
          align: 'center',
          value: 'delete',
          visible: true,
          sortable: false,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter((h) => h.visible)
    },
  },
  methods: {
    ...call('trackedBillAgency', ['deleteTrackedBillAgency']),
    refresh() {
      this.$emit('refreshAgencyPermissions')
    },
  },
}
</script>
<style>
</style>